import { render, staticRenderFns } from "./SfAccordion.vue?vue&type=template&id=655c4c8b&"
import script from "./SfAccordion.vue?vue&type=script&lang=ts&"
export * from "./SfAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./SfAccordion.vue?vue&type=style&index=0&id=655c4c8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports